import usePresentPage, { selectors } from 'client/hooks/usePresentPage'
import { PageLocaleEnum, PageLocaleNames } from 'common/enums/PageLocaleEnum'
import React from 'react'
import { CheckboxNew } from 'src/editor/shared/ui-lib/checkbox-new'

type LanguageCheckBoxProps = {
  update: (excludeLanguagesList: string[]) => void
  excludeLanguagesList: string[]
}

const languageList = Object.keys(PageLocaleNames) as PageLocaleEnum[]

function LanguageCheckList({
  update,
  excludeLanguagesList = [],
}: LanguageCheckBoxProps) {
  const locale = usePresentPage(selectors.getPageLocale)

  const currentLocale: string = locale === 'pt' ? 'br' : locale

  const handleLanguageExclude = (language: string) => (isExcluded: boolean) => {
    if (isExcluded) {
      update(
        excludeLanguagesList.filter(
          excludedLanguage => excludedLanguage !== language,
        ),
      )
    } else {
      update([...excludeLanguagesList, language])
    }
  }

  return (
    <>
      {languageList.map((language, key) => {
        return (
          <CheckboxNew
            key={key}
            wrapperClassName="mt-1"
            label={PageLocaleNames[language]}
            skipTranslation
            onChange={handleLanguageExclude(language)}
            checked={!excludeLanguagesList.includes(language)}
            disabled={language === currentLocale}
          />
        )
      })}
    </>
  )
}

export default LanguageCheckList
